export function getCachedPreference() {
  return JSON.parse(localStorage.getItem('redirectPreference'));
}

export function setCachedPreference(preference) {
  localStorage.setItem('redirectPreference', JSON.stringify(preference));
}
